import { render, staticRenderFns } from "./Workers.vue?vue&type=template&id=384a53f2"
import script from "./Workers.vue?vue&type=script&lang=ts"
export * from "./Workers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports